import { render, staticRenderFns } from "./ModifierGroupListItem.vue?vue&type=template&id=48556313"
import script from "./ModifierGroupListItem.vue?vue&type=script&lang=js"
export * from "./ModifierGroupListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports